module.exports = __webpack_public_path__ + "static/bg-showcase-1-260e7037dc0bb3aacf56c89d3d838a03.jpg";